var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"mb-32 px-16 sm:px-24 test"},[_c('table-component',{ref:"table",attrs:{"loading":_vm.loadingButton},on:{"on-send":_vm.onSendEmail}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }